import { FUTBOL_TEAMS, RUGBY_TEAMS } from '../../shared';
import { extractRounds } from '../helpers/get-rugby-rounds';
import { RUGBY_URBA_12_MATCHES } from './matches/matches-urba-12';

// Rounds de Rugby
export const RUGBY_ROUNDS_URBA_12 = extractRounds(RUGBY_URBA_12_MATCHES);

export const RUGBY_ROUNDS = RUGBY_ROUNDS_URBA_12;

// Sports disponibles
export const SPORTS = [
  { value: 'futbol', label: 'Fútbol' },
  { value: 'rugby', label: 'Rugby' }
];

// Configuración de cada sport
export const SPORT_CONFIG = {
  futbol: {
    teams: FUTBOL_TEAMS,
    leagues: [{ value: 'conmebol-libertadores', label: 'Copa Libertadores' }],
    tournaments: [
      { value: 'generico', label: 'Genérico' },
      { value: 'libertadores', label: 'Libertadores' }
    ]
  },
  rugby: {
    teams: RUGBY_TEAMS,
    leagues: [{ value: 'urba-top-12', label: 'URBA Top 12' }],
    tournaments: [{ value: 'generico', label: 'Genérico' }],
    rounds: RUGBY_ROUNDS
  }
};
